import { Link } from "react-router-dom";

export const ReassuranceSection = () => {
  return (
    <section className="py-28 bg-background" id="about" aria-label="About">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-5 gap-14 items-center">

            {/* Text — 3 cols */}
            <div className="md:col-span-3">
              <div className="flex items-center gap-3 mb-7">
                <div className="h-px w-8 bg-gold/60" />
                <p className="font-cinzel text-[0.6rem] text-gold tracking-[0.35em] uppercase">The Approach</p>
              </div>
              <h2 className="font-serif font-light text-foreground mb-7"
              style={{ fontSize: "clamp(1.8rem, 3.5vw, 2.5rem)" }}>
                A Planning Partner,<br />Not Just a Booking Agent
              </h2>
              <div className="space-y-5 text-muted-foreground leading-relaxed font-sans">
                <p>
                  Disney planning isn't complicated because it's Disney — it's complicated because there are hundreds of decisions to make before you ever step foot in a park. Dining windows, resort tiers, park-hopper timing, Lightning Lane™ sequencing. The system rewards preparation.
                </p>
                <p>
                  At Peacefully Ever After Travels, I don't hand you a brochure and wish you luck. I build your trip with you — deliberate, structured, and tailored to your family — then I stay involved until you're home.
                </p>
              </div>
              <div className="mt-9">
                <Link
                  to="/about"
                  className="inline-flex items-center gap-2 font-cinzel text-[0.6rem] tracking-[0.25em] uppercase px-6 py-3 bg-gold hover:bg-[hsl(46,80%,60%)] text-[hsl(222,64%,10%)] rounded-[2px] transition-smooth shadow-gold">

                  About MY Approach
                </Link>
              </div>
            </div>

            {/* Stats panel — 2 cols */}
            <div className="md:col-span-2">
              <div className="bg-card rounded-[3px] border border-border p-8 space-y-8 relative overflow-hidden">
                {/* Gold shimmer line at top */}
                <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-gold/60 to-transparent" />

                {[
                { stat: "100%", label: "Fee-free to you — advisors are paid by travel suppliers, not clients." },
                { stat: "WDW First", label: "Walt Disney World® is my primary specialty. It's where I invest the deepest expertise." },
                { stat: "End-to-End", label: "We stay involved from first conversation through your return home." }].
                map((item, i) =>
                <div key={i} className={i > 0 ? "pt-8 border-t border-border/60" : ""}>
                    <p className="font-serif text-2xl font-semibold text-gold mb-2 leading-tight">
                      {item.stat}
                    </p>
                    <p className="font-sans text-[0.825rem] text-muted-foreground leading-relaxed">
                      {item.label}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};